var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.357,
    height: 18.5,
    viewBox: "0 0 13.357 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-6.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-1750.25-1242a4.755,4.755,0,0,1,4.75-4.75,4.755,4.755,0,0,1,4.749,4.75,4.755,4.755,0,0,1-4.749,4.75A4.755,4.755,0,0,1-1750.25-1242Zm1.786,0a2.968,2.968,0,0,0,2.965,2.965,2.968,2.968,0,0,0,2.964-2.965,2.968,2.968,0,0,0-2.964-2.965A2.968,2.968,0,0,0-1748.464-1242Z",
    transform: "translate(1758.679 1248.75)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-1738.428-1238.536a.25.25,0,0,1-.25-.25V-1242a2.968,2.968,0,0,0-2.965-2.965h-3.856a2.968,2.968,0,0,0-2.965,2.965v3.214a.25.25,0,0,1-.25.25H-1750a.25.25,0,0,1-.25-.25V-1242a4.755,4.755,0,0,1,4.75-4.75h3.856a4.755,4.755,0,0,1,4.75,4.75v3.214a.25.25,0,0,1-.25.25Z",
    transform: "translate(1756.75 1259.036)",
    fill: "#74613c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0058e6877213a95d375d1163dbc306db.svg";
export { ForwardRef as ReactComponent };